/**
 * 存到本地存储的操作都在这里定义，方便统一处理
 */

export const $_MYSTERY_BOX_FORM_STORAGE_KEY = '$_MYSTERY_BOX_FORM_STORAGE_KEY'
export const $_PRODUCT_FORM_STORAGE_KEY = '$_PRODUCT_FORM_STORAGE_KEY'

export function storeMysteryBoxForm(data: Object) {
  localStorage.setItem($_MYSTERY_BOX_FORM_STORAGE_KEY, JSON.stringify(data))
}

export function getMysteryBoxForm(): Object {
  const item = localStorage.getItem($_MYSTERY_BOX_FORM_STORAGE_KEY)
  if (!item) return {}

  return JSON.parse(item)
}

export function clearMysteryBoxForm() {
  localStorage.removeItem($_MYSTERY_BOX_FORM_STORAGE_KEY)
}

export function setStorage(key: string, data: Object) {
  localStorage.setItem(key, JSON.stringify(data))
}

export function getStorage(key: string): Object {
  const value = localStorage.getItem(key)
  if (!value) return {}

  return JSON.parse(value)
}

export function clearStorage(key: string) {
  localStorage.removeItem(key)
}
